import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoiceSettingsFormWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  padding: ${Spacing.S32} ${Spacing.S40};
  border: 1px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R12} 0 0 ${BorderRadius.R12};
  background-color: ${Color.White};
`

export const FormContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S32};
  width: 100%;
  height: 100%;
  max-height: 100%;
  padding-right: ${Spacing.S16};
  overflow: scroll;

  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  &:hover {
    ::-webkit-scrollbar-thumb {
      background-color: ${Color.Grey150};
    }
  }
`
